import { render, staticRenderFns } from "./ContentSizeChart.vue?vue&type=template&id=0b35f86c&scoped=true&"
import script from "./ContentSizeChart.vue?vue&type=script&lang=js&"
export * from "./ContentSizeChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b35f86c",
  null
  
)

/* custom blocks */
import block0 from "./ContentSizeChart.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports